import { DatasetDataInfoResponse } from "api/model/dataset/DatasetDataInfoResponse";
import { NodeValues, SankeyDiagramGraph } from "components/dashboard/charts/sankey-chart/sankey-types";
import { addToDate, DweenTimeUnitEnum, fmtDateUntilUnit, truncateDate } from "utils/time-utils";
import { Instant, ZoneId } from "@js-joda/core";

export const minimalNumber = 0.000000000001;

export const validatedConfigIsCorrect = (graph: SankeyDiagramGraph): string => {
  const nodesId = graph.nodes.map(e => e.id);

  let correct: string = "";
  graph.links.forEach(l => {
    if (!nodesId.includes(l.source)) {
      correct = l.source;
    }
    if (!nodesId.includes(l.target)) {
      correct = l.target;
    }
  });

  return correct;
};

export const findResponseByIdentifier = (
  data: Array<DatasetDataInfoResponse>,
  givenIdentifier: string
): DatasetDataInfoResponse | undefined => {
  return data.find(item => item.identifier === givenIdentifier);
};

export const getPercentage = (value: number, fullVal: number) => {
  return fullVal > 0 ? (value * 100) / fullVal : 0;
};

export function extractValueByNodeName(arr: NodeValues[], nodeName: string) {
  for (let i = 0; i < arr.length; i++) {
    if (arr[i].nodeName === nodeName) {
      return arr[i].value;
    }
  }
  return undefined;
}

export const extractUniqueNames = (
  graph: SankeyDiagramGraph,
  nodeVal: NodeValues[],
  refValue: number,
  configDecimalPlace?: number,
  configPercentagesDecimalPlaces = 1
): string[] => {
  const mapped = graph.nodes.map(n => {
    const node = nodeVal.find(item => item.nodeName === n.id);
    const val = node ? node.value : 0;
    const index = node ? nodeVal.indexOf(node) : -1;

    return `${n.title}<br> ${getPercentage(val, refValue).toFixed(
      configPercentagesDecimalPlaces
    )}% | ${val.toFixed(configDecimalPlace || nodeVal[index].decimalPlace)} ${nodeVal[index].unit}`;
  });

  return Array.from(mapped);
};

export const extractValue = (val: number, configDecimalPlace: number) => {
  if (val <= minimalNumber) {
    return 0;
  } else {
    return val.toFixed(configDecimalPlace);
  }
};

export const makeCustomData = (
  value: number | undefined,
  unit: string | undefined,
  title: string | undefined,
  date: string | undefined,
  sourceNodeTitle: string | undefined,
  nodeValue: number | undefined,
  tz: ZoneId
) => {
  return `${value && value >= minimalNumber ? value : 0} ${unit || ""}<br>${sourceNodeTitle && value && nodeValue ? `${((value * 100) / nodeValue).toFixed(2)}% nuo ${sourceNodeTitle}<br>` : ""}${title || ""}<br>${date ? fmtDateUntilUnit(date, DweenTimeUnitEnum.SECONDS, tz) : ""}`;
};

export const timeSetWithConfig = (
  refTime: Instant | undefined,
  companyTz: ZoneId,
  dateConfig: {
    alignStartTo?: DweenTimeUnitEnum;
    timeOffset?: number;
    timeOffsetUnits?: DweenTimeUnitEnum;
  }
): Date => {
  if (refTime) {
    return refTime.toDate();
  }

  let tempDate =  Instant.now().atZone(companyTz).toDate();

  if (dateConfig.alignStartTo) {
    tempDate = truncateDate(tempDate, dateConfig.alignStartTo, companyTz);
  }

  if (dateConfig.timeOffset != null || dateConfig.timeOffsetUnits) {
    tempDate = addToDate(
      tempDate,
      dateConfig.timeOffset != null ? dateConfig.timeOffset : 0,
      dateConfig.timeOffsetUnits || DweenTimeUnitEnum.MINUTES
    );
  }

  return tempDate;
};